<template>
  <div id="app">
    <router-view/>
    <fullScreenLoadingView></fullScreenLoadingView>
    <!-- Safari 推播提示 -->
    <safariPushPrompt ref="safariPushPrompt"
      @triggerPushSetupHandle="triggerPushSetup"
    ></safariPushPrompt>
  </div>
</template>

<script>
import fullScreenLoadingView from '@/views/fullScreenLoadingView.vue'
import { initFcmServiceWorker } from '@/assets/js/firebase';
import safariPushPrompt from '@/views/public/safariPushPrompt.vue'
import { setLocale } from '@/i18n'
export default {
    name: 'App',
    components: {
      fullScreenLoadingView , safariPushPrompt
    },
    data(){
      return {
        isSafari: false,
      }
    },
    watch:{
      $route(to,from){
        
      }
    },
    methods:{
      upDateFcmToken(currentToken){
        this.$api.users.upDateFcmToken(currentToken)
      },
      isSafariBrowser() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      },
      /** 統一的權限申請流程（可被按鈕或程式呼叫） */
      async triggerPushSetup() {
        // 若權限已在其他流程授權過，就不用再詢問
        if (Notification.permission === 'granted') {
          initFcmServiceWorker(this.upDateFcmToken);
          this.$refs.safariPushPrompt.showSafariPushPrompt = false;
          return;
        }

        // 只有非-Safari 能用 requestPermission()
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          initFcmServiceWorker(this.upDateFcmToken);
          this.$refs.safariPushPrompt.showSafariPushPrompt = false;
        } else {
          alert('已拒絕推播權限，無法接收通知。');
        }
      },
    },
    mounted(){


      const currentDomain = window.location.hostname;
      //判斷如果是中國版本，則轉跳到中國的路由去
      if (currentDomain.endsWith('auu.tw')) {
        try {
          setLocale('zh-CN')
        } catch (error) {
          console.error('[App] Failed to force i18n to zh-CN:', error)
        }
        return
      }

      this.isSafari = this.isSafariBrowser();
      console.log('this.isSafari =', this.isSafari);

      switch (Notification.permission) {
        case 'granted':
          // ✅ 已授權
          initFcmServiceWorker(this.upDateFcmToken);
          break;

        case 'default':
          if (this.isSafari) {
            // ❗ Safari 必須靠 UI 觸發 → 顯示自訂提示元件
            this.$refs.safariPushPrompt.showSafariPushPrompt = true;
          } else {
            // 其餘瀏覽器可直接呼叫統一流程
            this.triggerPushSetup();
          }
          break;

        case 'denied':
        default:
          // ❌ 被拒絕，僅記錄不再打擾
          console.warn('🔕 通知權限已被拒絕');
      }

    },
    created(){
      
    }
}
</script>
<style>
body{
  background-color: rgb(171 196 228 / 30%) !important;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  color: #2c3e50 !important;
}
.view-content-box{
    width: 100%;
    background-color: #ffffff;
    padding: 2rem;
    border-radius: 2rem;
}
.content-body > div {
  position: relative;
}
@media (max-width: 948px) {
  .view-content-box{
    margin-top:4rem;
  }
}
</style>
